import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getRelatorio } from '../../actions/relatorioActions'
import moment from 'moment'

const DIFF_MESES = 3;

class Relatorio extends Component {
    constructor(){
        super()
        this.state = {
            filtro: {
                dataInicial: moment().subtract({months: DIFF_MESES}).format('YYYY-MM-DD'),
                dataFinal: moment().format('YYYY-MM-DD'),
            },
            dataInicial: moment().subtract({months: DIFF_MESES}).format('YYYY-MM-DD'),
            dataFinal: moment().format('YYYY-MM-DD'),
            perPage: 10,
            erroFiltroData: '',
        }
    }

    async componentDidMount(){
        this.props.getRelatorio(1, this.state.perPage, this.state.filtro)   
    }

    changeValue = (target) => this.setState({
        filtro: { ...this.state.filtro, [target.name]: target.value },
        [target.name]: target.value,
    })

    onSubmit = (event) => {
        event.preventDefault();

        const diferencaMeses = moment(this.state.dataFinal).diff(moment(this.state.dataInicial), 'months', true);
        if (diferencaMeses > DIFF_MESES) {
            this.setState({
                erroFiltroData: `Diferença entre a data inicial e final do filtro deve ser de no máximo ${DIFF_MESES} meses.`,
            });
            const { perPage } = this.state
            this.props.getRelatorio(1, perPage, {
                dataInicial: moment().add({days: 1}).format('YYYY-MM-DD'),
                dataFinal: moment().add({days: 1}).format('YYYY-MM-DD'),
            });
        } else {
            this.setState({ erroFiltroData: '' });
            const { perPage } = this.state
            this.props.getRelatorio(1, perPage, this.state.filtro);
        }        
    }

    qntLinks(){
        const paginate = {
            lastPage: parseInt(this.props.relatorio.list.lastPage),
            page: parseInt(this.props.relatorio.list.page),
        }
        let qntArray;

        if (paginate.lastPage <= 10) {
            qntArray = new Array(paginate.lastPage).fill(1);

            return qntArray.map((v,i) => {
                return paginate.page === i+1
                    ? (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
                    : (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
            })
        } else {
            qntArray = new Array(7).fill(1);
            if (paginate.page <= 3) {
                return qntArray.map((v, i) => {
                    if (i < 5) {
                        return paginate.page === i+1
                            ? (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
                            : (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
                    } else if (i === 5) {
                        return (<li key={'etc1'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.lastPage)}>{paginate.lastPage}</a></li>)
                    }
                })
            } else if (paginate.lastPage - paginate.page <= 3) {
                return qntArray.map((v, i) => {
                    if (i > 1) {
                        const page = paginate.lastPage - 7 + i + 1;
                        return paginate.page === page
                            ? (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(page)}>{page}</a></li>)
                            : (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(page)}>{page}</a></li>)
                    } else if (i === 1) {
                        return (<li key={'etc1'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(1)}>{1}</a></li>)
                    }
                })
            } else {
                return qntArray.map((v, i) => {
                    if (i === 0) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(1)}>{1}</a></li>)
                    } else if (i === 1) {
                        return (<li key={'etc1'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else if (i === 2) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.page - 1)}>{paginate.page - 1}</a></li>)
                    } else if (i === 3) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(paginate.page)}>{paginate.page}</a></li>)
                    } else if (i === 4) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.page + 1)}>{paginate.page + 1}</a></li>)
                    } else if (i === 5) {
                        return (<li key={'etc2'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.lastPage)}>{paginate.lastPage}</a></li>)
                    }
                })
            }
        }
    }

    pagination(page){
        let { perPage } = this.state
        let { lastPage } = this.props.relatorio.list
        page = page < 1 ? 1 : page
        
        if(page <= lastPage && page > 0)
            this.props.getRelatorio(page, perPage, this.state.filtro);
    }

    render(){
        const { 
            loading, list,
            assinaturasRealizadas, assinaturasRequisitadas, smsEnviadosTotal, whatsAppEnviadosTotal, serproBiometriaFacialConsultadasTotal,
            cancelados, concluidos, contratos, qntUsuarios
        } = this.props.relatorio;

        const { erroFiltroData } = this.state;

        const { page } = list

        var listContracts = (Object.keys(list || {}).includes('data')) ? list.data : list 
        const qntUsers = qntUsuarios
        return (
            <main role="main" className="col-md-10 ml-sm-auto col-lg-10 px-3">
                <div style={{ padding: 10 }}>
                    <h1 style={{ textAlign: 'center'}}>Relatorio</h1>
                    <div>
                        <div className="bg-white rounded shadow-sm p-3">

                            <h6 className="pb-2 mb-0">Filtros</h6>

                            <form onSubmit={ event => this.onSubmit(event)} className='border-bottom border-gray' style={{ marginBottom: 10, paddingTop: 10, paddingBottom: 10 }}>
                                <div style={{ display:'flex', flexWrap: 'wrap'}}>
                                    
                                    <div className="form-group" style={{ marginRight: 8 }}>
                                        <span>Data Inicio:</span>
                                        <input name="dataInicial" type="date" value={this.state.dataInicial} className="form-control" 
                                            placeholder="Data Inicio" 
                                            onChange={({ target }) => this.changeValue(target)} />
                                    </div>


                                    <div className="form-group" style={{ marginRight: 8 }}>
                                        <span>Data Fim:</span>
                                        <input name="dataFinal" type="date" value={this.state.dataFinal} className="form-control"
                                            placeholder="Data Fim" 
                                            onChange={({ target }) => this.changeValue(target)} />
                                    </div>

                                    <div className="form-group" style={{ marginRight: 8 }}>
                                        <span>Por página:</span>
                                        <select name='perPage' className="form-control form-group" 
                                            onChange={({ target }) => this.setState({ perPage: parseInt(target.value) })}  >
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={0}>TODOS</option>
                                        </select>
                                    </div>
                                </div>

                                {erroFiltroData ? <div style={{ marginTop: '-26px', marginBottom: '0.5rem', color: 'red', fontWeight: 'bold' }}>
                                    <span>{ erroFiltroData }</span>
                                    <br/>
                                </div>: null}                    
                                
                                <button disabled={loading} className="btn my-2 my-sm-0 btn-primary" type="submit">Pesquisar</button>
                            </form>

                            {/* loading */}
                            {loading
                                ?<div className="spinner-border" role="status" style={{margin:'5%'}}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                                :null
                            }

                            {/* RESUMO */}
                            <div className="border-bottom border-gray pb-2 mb-0">
                                <h7 className=" border-gray pb-2 mb-0">Resumo Geral:</h7>
                                <table className="table table-striped" style={{ marginTop: 8}}>
                                    <thead >
                                        <tr>
                                            <th scope="col">Total Documentos</th>
                                            <th scope="col">Qntd usuários</th>
                                            <th scope="col">Documentos Finalizados</th>
                                            <th scope="col">Documentos Cancelados</th>
                                            <th scope="col">Total Assinaturas</th>
                                            <th scope="col">Total Assinaturas Finalizadas</th>
                                            <th scope="col">Total de SMS Enviados</th>
                                            <th scope="col">Total de WhatsApp Enviados</th>
                                            <th scope="col">Total de Biometrias Faciais (SERPRO) Consultadas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{contratos}</td>
                                            <td>{qntUsers}</td>
                                            <td>{concluidos}</td>
                                            <td>{cancelados}</td>
                                            <td>{assinaturasRequisitadas}</td>
                                            <td>{assinaturasRealizadas}</td>
                                            <td>{smsEnviadosTotal}</td>
                                            <td>{whatsAppEnviadosTotal}</td>
                                            <td>{serproBiometriaFacialConsultadasTotal}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Contratos */}    
                            <div className="media text-muted pt-2 " style={{ marginRight: 8, minWidth: '16rem',display:'flex',flexDirection:'column'}}>
                                <h6 className="" style={{ width: '100%', color:'black'}}>Lista:</h6>
                                <table className="table table-striped" style={{ marginTop: 8}}>
                                    <thead className="thead-dark">
                                        <tr>
                                            <th scope="col">Nº Documento</th>
                                            <th scope="col">Nome Documento</th>                                       
                                            <th scope="col">Usuário</th>
                                            <th scope="col">Data Criação</th>
                                            <th scope="col">Data Finalização</th>
                                            <th scope="col">Assinaturas</th>
                                            <th scope="col">SMS Enviados</th>
                                            <th scope="col">WhatsApp Enviados</th>
                                            <th scope="col">Biometrias Faciais (SERPRO) Consultadas</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list &&
                                            listContracts.map( (contrato, index) => {
                                                const { titulo, assinaturas, smsEnviados, whatsAppEnviados, serproBiometriaFacialConsultadas, dataFinalizacao, dataCriacao, numero, numero_externo, finalizado_em, user, status } = contrato

                                                return (
                                                    <tr key={`contrato${index}`}>
                                                        <td>{numero || numero_externo}</td>
                                                        <td>{titulo}</td>
                                                        <td>{user.nome}</td>
                                                        <td>{dataCriacao.replace(' - ',' ')}</td>
                                                        <td>{dataFinalizacao || finalizado_em}</td>
                                                        <td>{(assinaturas || '').replace('Assinaturas: ', '')}</td>
                                                        <td>{smsEnviados}</td>
                                                        <td>{whatsAppEnviados}</td>
                                                        <td>{serproBiometriaFacialConsultadas}</td>
                                                        <td>{status}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>

                                <nav aria-label="Page navigation example">
                                    <ul className="pagination mt-3">
                                        <li className="page-item">
                                            <button className="page-link" aria-label="Previous" onClick={ () => this.pagination(parseInt(page) - 1)}>
                                                    <span aria-hidden="true">&laquo;</span>
                                                    <span className="sr-only">Previous</span>
                                            </button>
                                        </li>
                                        {
                                            this.qntLinks()
                                        }
                                        
                                        <li className="page-item">
                                            <button className="page-link" aria-label="Next" onClick={ () => this.pagination(parseInt(page) + 1)}>
                                                    <span aria-hidden="true">&raquo;</span>
                                                    <span className="sr-only" >Next</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                                                        
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

const styles = {
    totalStatus: { marginRight: 8}
}

const mapStateToProps = ({ relatorio }) => {
    return {
        relatorio
    }
}

export default connect(mapStateToProps, {
    getRelatorio
})(Relatorio);
